import React, { Component } from "react";

export default class AstrologicalSymbol extends Component {
    render() {
        return (
            <img className={this.props.className || ''} style={this.props.style || ''} src={`/signs/${this.props.symbol}.png`} alt={this.props.symbol}/>
        );
    }
}